// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font-family-gol: Gol Sans Display;
  --font-family-smiles: Nunito;
  --font-family-base: Nunito Sans;
  --font-weight-light: 300;
  --font-weight-regular: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  --font-size-3xs: 0.75rem;
  --font-size-2xs: 0.875rem;
  --font-size-xs: 1rem;
  --font-size-sm: 1.25rem;
  --font-size-md: 1.5rem;
  --font-size-lg: 2rem;
  --font-size-xl: 2.5rem;
  --font-size-2xl: 3rem;
  --font-size-3xl: 4rem;
  --line-height-default: 100%;
  --line-height-xs: 115%;
  --line-height-sm: 125%;
  --line-height-md: 135%;
  --line-height-lg: 145%;
  --line-height-xl: 155%;
  --letter-spacing-default: 0em;
  --letter-spacing-negative: -0.02em;
  --letter-spacing-positive: 0.01em;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@gol-smiles/tangerina-tokens/dist/web/globals/typography.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;EAC7B,kCAAkC;EAClC,iCAAiC;AACnC","sourcesContent":[":root {\n  --font-family-gol: Gol Sans Display;\n  --font-family-smiles: Nunito;\n  --font-family-base: Nunito Sans;\n  --font-weight-light: 300;\n  --font-weight-regular: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n  --font-size-3xs: 0.75rem;\n  --font-size-2xs: 0.875rem;\n  --font-size-xs: 1rem;\n  --font-size-sm: 1.25rem;\n  --font-size-md: 1.5rem;\n  --font-size-lg: 2rem;\n  --font-size-xl: 2.5rem;\n  --font-size-2xl: 3rem;\n  --font-size-3xl: 4rem;\n  --line-height-default: 100%;\n  --line-height-xs: 115%;\n  --line-height-sm: 125%;\n  --line-height-md: 135%;\n  --line-height-lg: 145%;\n  --line-height-xl: 155%;\n  --letter-spacing-default: 0em;\n  --letter-spacing-negative: -0.02em;\n  --letter-spacing-positive: 0.01em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
